var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";
import { IconoirContext } from "./IconoirContext.mjs";

function SvgHeart(passedProps, svgRef) {
  var context = React.useContext(IconoirContext);

  var props = __assign(__assign({}, context), passedProps);

  return React.createElement("svg", __assign({
    width: "1.5em",
    height: "1.5em",
    strokeWidth: 1.5,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: "currentColor",
    ref: svgRef
  }, props), React.createElement("path", {
    d: "M22 8.862a5.95 5.95 0 01-1.654 4.13c-2.441 2.531-4.809 5.17-7.34 7.608-.581.55-1.502.53-2.057-.045l-7.295-7.562c-2.205-2.286-2.205-5.976 0-8.261a5.58 5.58 0 018.08 0l.266.274.265-.274A5.612 5.612 0 0116.305 3c1.52 0 2.973.624 4.04 1.732A5.95 5.95 0 0122 8.862z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }));
}

var ForwardRef = React.forwardRef(SvgHeart);
export default ForwardRef;